module.exports = __webpack_public_path__ + "img/04.391765e5.png";